import React, { useState } from "react";
import { useSelector } from "react-redux";
import EmployeeTableRow from "../../molecules/EmployeeTableRow/EmployeeTableRow";
import './Employees.scss'
import AddButton from '../../atoms/AddButton/AddButton';
import ActiveFiltersDropdown from '../../atoms/ActiveFiltersDropdown/ActiveFiltersDropdown';
import AddEmployeeModal from "../../molecules/AddEmployeeModal/AddEmployeeModal";
import PageLoderSpinner from "../../atoms/PageLoaderSpinner/PageLoderSpinner";

const Employees = () => {
  const { employeesList, isLoadingEmployees } = useSelector(state => state.employees);
  const [showAddEmployeeModal, setShowDeleteModal] = useState(false);

  return (
    <>
      {showAddEmployeeModal && (
        <AddEmployeeModal
          onCancel={() => setShowDeleteModal(false)}
          onConfirm={() => setShowDeleteModal(false)}
        /> 
      )}
          
      <div className="employees-container">
        <div className="row header-container d-flex justify-content-between align-items-center" style={{margin: '20px 0px 47px'}}>
          <h5 className="text-uppercase font-weight-normal">Employees</h5>
          <AddButton clickHandler={() => setShowDeleteModal(true)} />
        </div>
        <div className="row mb-3">
          <div className="col-md-3 col-sm-12 d-flex justify-content-end align-items-center">
            <span className="mr-3">Type</span>
            <ActiveFiltersDropdown endpoint="users" />
          </div>
        </div>

        {isLoadingEmployees
          ? <div className="spinner-wrapper"><PageLoderSpinner /></div>
          : (
              <div className="employees-table table-responsive">
                <table className="table table-striped w-100">
                  <colgroup>
                    <col width="5%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="19%" />
                    <col width="15%" />
                    <col width="5%" />
                  </colgroup>
                  <thead className="border-top-0 text-uppercase">
                    <tr>
                      <th className="border-0" />
                      <th className="border-0 text-left font-weight-normal">name</th>
                      <th className="border-0 text-center font-weight-normal">username</th>
                      <th className="border-0 text-center font-weight-normal">Password</th>
                      <th className="border-0 text-center font-weight-normal text-nowrap">weekly Working Hours</th>
                      <th className="border-0 text-center font-weight-normal text-nowrap">Starting date</th>
                      <th className="border-0 text-center font-weight-normal">type</th>
                      <th className="border-0" />
                    </tr>
                  </thead>
                  <tbody>
                    {employeesList.length > 0 ? (
                      employeesList?.map((employee) => (
                        <EmployeeTableRow key={employee.id} employee={employee}  />
                      ))
                    ) : (
                      <div>No employees are available to display..</div>
                    )}
                  </tbody>
                </table>
              </div>
            )
        }
      </div>
    </>
  );
}

export default Employees